<template>
  <div class="ui basic segment estero-listing">
    <h3 class="header">{{ $t('ESTERO') }}</h3>
    <div class="active content">
      <div class="ui  secondary pointing menu">
        <router-link
          class="item"
          :to="{ name: 'estero-with-view-code', params: { mode: 'novice', code: encodedViewCode } }"
          :active-class="'active'"
          :class="{ disabled: simpleCannotDisplay }"
        >
          {{ $tc('ESTERO_SIMPLE', 2) }}
        </router-link>
        <router-link
          class="item"
          :to="{ name: 'estero-with-view-code', params: { mode: 'expert', code: encodedViewCode } }"
          :active-class="'active'"
        >
          {{ $tc('ESTERO_ADVANCED', 2) }}
        </router-link>
        <div class="right menu">
          <a class="item" @click="topCollapsed = !topCollapsed">
            <i :class="{ off: topCollapsed, on: !topCollapsed }" class="toggle icon" />{{
              $t('SHOW_CONTROLS')
            }}
          </a>
        </div>
      </div>

      <!-- ADVANCED --->
      <div class="ui active bottom basic segment" v-if="!topCollapsed && mode === 'expert'">
        <estero-advanced
          :viewId="viewId"
          :code="viewCode"
          @run-code="gotoViewCode"
          @goto-view="gotoView"
          :operators="operators"
          :properties="properties"
        />
      </div>

      <!-- SIMPLE --->
      <div class="ui bottom active basic segment" v-if="!topCollapsed && mode === 'novice'">
        <estero-simple
          @run-code="gotoViewCode"
          :code="viewCode"
          :operators="operators"
          :properties="properties"
        />
      </div>
    </div>

    <estero-list
      :page="page"
      v-on:filterby-updated="gotoViewCode"
      v-on:page-updated="onAtPageChange($event)"
      v-on:sortby-updated="onSortByChange($event)"
      class="estero-list"
      :outsideHeaderHeight="headerHeight"
      :properties="properties"
    />
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.estero-listing {
  display: flex;
  flex-direction: column;

  .estero-list {
  }
}
</style>

<script>
// @flow
import { Estero, EsteroSocket, Toast } from 'services'
import EsteroList from './EsteroList'
import EsteroAdvanced from './EsteroAdvanced'
import EsteroSimple from './EsteroSimple'
import { KitchenPage } from 'ui'

import Vue from 'vue'

export default {
  name: 'estero',

  components: {
    EsteroList,
    EsteroSimple,
    EsteroAdvanced
  },

  data() {
    return {
      properties: [],
      viewCode: '',
      socket: null,
      page: new KitchenPage(),
      selected: [],
      allSelected: false,
      topCollapsed: false,
      operators: Estero.mql.operators
    }
  },

  props: ['mode', 'viewId', 'code', 'sortByEnc', 'atPage'],

  computed: {
    sortBy() {
      return this.sortByEnc && this.sortByEnc.replace('<slash>', '/')
    },
    headerHeight() {
      if (this.topCollapsed) return 140
      if (this.mode === 'novice') return 260
      if (this.mode === 'expert') return 460
      return 260
    },
    encodedViewCode() {
      return btoa(encodeURIComponent(this.viewCode || ''))
    },
    simpleCannotDisplay() {
      return /OR/i.test(this.viewCode)
    }
  },

  methods: {
    updateSocketState(state) {
      console.debug('updateSocketState', state.sortBy, state.atPage)
      this.page.loading = true
      this.socket.update({
        view: this.viewCode || '',
        paging: { page: parseInt(state.atPage, 10) || 0, pagesize: this.page.pageSize },
        sortBy: state.sortBy === '-' ? '' : state.sortBy
      })
    },

    onSortByChange(sortBy) {
      console.debug('onSortByChange', sortBy)
      this.updateSocketState({ sortBy, atPage: this.page.currentPage, viewId: this.viewId })
      this.updateViewRoute({ sortBy })
    },

    onAtPageChange(atPage) {
      this.updateSocketState({ atPage, sortBy: this.sortBy, viewId: this.viewId })
      this.updateViewRoute({ atPage })
    },

    // This handler will update the code displayed and execute the view function
    onViewCodeChange(code) {
      this.viewCode = code
      console.debug('onViewCodeChange')
      this.updateSocketState(this)
    },

    updateViewRoute(params) {
      console.debug('updateViewRoute', params.code, this.viewCode, this.code)
      const viewId = params.viewId
      const code = btoa(encodeURIComponent(params.code || this.viewCode || '-'))
      const sortByEnc = (params.sortBy || this.sortBy || '-').replace('/', '<slash>')
      const atPage = _.find([params.atPage, this.atPage, 0], p => typeof p == 'number')
      this.$router.push({
        name: viewId ? 'estero-with-view-id' : code ? 'estero-with-view-code' : 'estero-with-all',
        params: {
          mode: this.mode,
          viewId,
          code,
          sortByEnc,
          atPage
        }
      })
    },

    gotoView(v) {
      this.updateViewRoute({ viewId: v.id, code: v.code })
    },

    gotoViewCode(code) {
      this.viewCode = code
      this.updateViewRoute({ viewId: null, code })
    }
  },

  watch: {
    code: function(c) {
      if (c) this.onViewCodeChange(decodeURIComponent(atob(c)))
    },
    // when we switch tabs we make sure the top isnt collapsed
    '$route.params.mode': function() {
      this.topCollapsed = false
    }
  },

  mounted() {
    Estero.availableSettings().then(settings => (this.properties = settings))
    this.socket = EsteroSocket()
    this.socket.on('close', () =>
      Toast.error(
        this.$i18n.t('ESTERO_CONNECTION_LOST_HEADER'),
        this.$i18n.t('ESTERO_CONNECTION_LOST_BODY')
      )
    )
    this.socket.on('message', p => {
      if (p.error) {
        Toast.error(this.$i18n.t('ESTERO_QUERY_ERROR'), p.error)
        this.page = new KitchenPage()
      } else {
        this.page = new KitchenPage(p)
      }
    })

    this.socket.on('open', () => {
      // mounted with code
      if (!this.$route.params.viewId && this.code)
        this.onViewCodeChange(decodeURIComponent(atob(this.code)))
      // ensure we get the proper data loaded if we only get a view-id
      else if (this.$route.params.viewId) {
        Estero.getViews().then(views => {
          let view = _.find(views, v => v.id == this.$route.params.viewId)
          if (view) this.onViewCodeChange(view.code)
        })
      }
    })

    this.columns = this.defaultColumns
  },

  beforeDestroy() {
    if (this.socket) this.socket.remove()
  }
}
</script>
